import { render, staticRenderFns } from "./covernew.vue?vue&type=template&id=2a545f16&scoped=true&"
import script from "./covernew.vue?vue&type=script&lang=js&"
export * from "./covernew.vue?vue&type=script&lang=js&"
import style0 from "./covernew.vue?vue&type=style&index=0&id=2a545f16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a545f16",
  null
  
)

export default component.exports